import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { get } from "lodash";

/** Экспорт табличных данных отчёта в .xlsx */
export const generateExcelFile = ({ data, headers, fileName }) => {
  const rows = data.map((item) => {
    const row = {};
    for (const header of headers) {
      const value = get(item, header.field);
      row[header.headerName] = value === undefined || value === null
        ? "-"
        : String(value);
    }
    return row;
  });

  const worksheet = XLSX.utils.json_to_sheet(rows);

  // Автоширина колонок: max(заголовок, значения) + 3
  worksheet["!cols"] = headers.map((header) => {
    const valuesWidths = rows.map(
      (row) => String(row[header.headerName] ?? "").length
    );
    return {
      wch: Math.max(header.headerName?.length ?? 0, ...valuesWidths, 0) + 3,
    };
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Страница 1");

  const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([buffer], { type: "application/octet-stream" });
  saveAs(blob, `${fileName}.xlsx`);
};
